import MenuItem from './menu-item.element.js';

export default MenuItem;

MenuItem.define('wje-menu-item', MenuItem);
